module.exports = __webpack_public_path__ + "img/empleado-dentalia.2d5a4a34.png";